export default "__VITE_ASSET__CPwNPlNq__"